"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const mappers_1 = require("../mappers/mappers");
const collection_1 = require("./collection");
/**
 * Models Firestore contents with types
 */
exports.store = {
    childAttendanceAdd: new collection_1.TenantIndexedCollection("child-attendances-add", "child-attendance-add"),
    childAttendanceDelete: new collection_1.TenantIndexedCollection("child-attendances-delete", "child-attendance-delete"),
    childAttendancesByChild: new collection_1.TenantIndexedCollection("child-attendances-by-child", "child-attendance-by-child"),
    childAttendancesByShift: new collection_1.TenantIndexedCollection("child-attendances-by-shift", "child-attendance-by-shift"),
    children: new collection_1.TenantIndexedMappingCollection("children", "child", mappers_1.childMapper),
    contactPeople: new collection_1.TenantIndexedMappingCollection("contact-people", "contact-person", mappers_1.contactPersonMapper),
    crewAttendancesAdd: new collection_1.TenantIndexedCollection("crew-attendances-add", "crew-attendance-add"),
    crewAttendancesDelete: new collection_1.TenantIndexedCollection("crew-attendances-delete", "crew-attendance-delete"),
    crewAttendancesByShift: new collection_1.TenantIndexedCollection("crew-attendances-by-shift", "crew-attendance-by-shift"),
    crewAttendancesByCrew: new collection_1.TenantIndexedCollection("crew-attendances-by-crew", "crew-attendance-by-crew"),
    crewMembers: new collection_1.TenantIndexedMappingCollection("crew-members", "crew-member", mappers_1.crewMapper),
    // TODO check if dates convert correctly (created and expires) for reports
    reports: new collection_1.TenantIndexedCollection("reports", "report"),
    shifts: new collection_1.TenantIndexedMappingCollection("shifts", "shift", mappers_1.shiftMapper),
    templates: new collection_1.TenantIndexedCollection("templates", "template"),
    tenants: new collection_1.TenantIndexedCollection("tenants", "tenant", true),
    users: new collection_1.Collection("users", "user"),
};
//# sourceMappingURL=store.js.map